import { energyAnalysisCacheKeys } from "features/energy-analysis-dashboard/api/cacheKeys";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import { downloadCrremSubsetTemplate, revertCrremSubsetOverrides, uploadCrremSubset } from "../api/callers";
import { formatCrremSubsetUploadError } from "../lib/parseCrremPathwayApi";

const invalidateCrremQueries = (queryClient: ReturnType<typeof useQueryClient>, projectId: string) => {
  void queryClient.resetQueries(energyAnalysisCacheKeys.allScenarios(projectId));
};

export const useCrremSubset = (projectId: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const uploadMutation = useMutation((file: File) => uploadCrremSubset(projectId, file), {
    onError: (error) => {
      void toast.error(formatCrremSubsetUploadError(error, t("general.failedSave")));
    },
    onSuccess: () => {
      toast.success(t("general.successfulFileUpload"));
      invalidateCrremQueries(queryClient, projectId);
    },
  });
  const revertMutation = useMutation(() => revertCrremSubsetOverrides(projectId), {
    onError: () => {
      void toast.error(t("general.failedReset"));
    },
    onSuccess: () => {
      toast.success(t("general.successfulReset"));
      invalidateCrremQueries(queryClient, projectId);
    },
  });
  return {
    downloadTemplate: () => downloadCrremSubsetTemplate(projectId, String(t("general.downloadFileProblem"))),
    isBusy: uploadMutation.isLoading || revertMutation.isLoading,
    isReverting: revertMutation.isLoading,
    isUploading: uploadMutation.isLoading,
    revertOverrides: revertMutation.mutate,
    uploadFile: uploadMutation.mutate,
  };
};
